import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";

const linkProps = { target: "_blank", rel: "noreferrer" };

export default function HeaderSocials() {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/trai-torti-7980341a2/" {...linkProps}>
        <BsLinkedin />
      </a>
      <a href="https://github.com/darthjeditt" {...linkProps}>
        <FaGithub />
      </a>
      <a href="https://www.instagram.com/traiflip/" {...linkProps}>
        <AiFillInstagram />
      </a>
    </div>
  );
}
